import { render } from "./AppBackButton.vue?vue&type=template&id=51e1c2c5"
import script from "./AppBackButton.vue?vue&type=script&lang=js"
export * from "./AppBackButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__